import React from "react";
import ReactDOM from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import { TagDataProvider } from "./context/TagContext";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<CookiesProvider>
			<TagDataProvider>
				<App />
			</TagDataProvider>
		</CookiesProvider>
	</React.StrictMode>
);
